export const API_PATH_ApiAppOptionsGet = '/services/app/apiAppOptionsGet';
